package ui.screens.section.welcome

import CompassDivider
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.material3.HorizontalDivider
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.text.style.TextAlign
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp
import androidx.compose.ui.zIndex
import models.ScrollSnapshot
import ui.composables.WonderTitleText

@Composable
fun WeddingWelcomeSection(textColor: Color, safeEntered: Boolean, scrollSnapshot: ScrollSnapshot) {
    Column(
        Modifier.fillMaxWidth()
            .padding(bottom = 16.dp)
            .zIndex(0.1f),
        horizontalAlignment = Alignment.CenterHorizontally
    ) {
        Text(
            "You are invited to",
            modifier = Modifier.padding(horizontal = 8.dp),
            style = MaterialTheme.typography.titleMedium.copy(
                fontWeight = FontWeight.Normal,
                fontSize = 20.sp,
            ),
            color = textColor,
        )
        Row(
            Modifier.padding(
                start = 16.dp,
                bottom = 16.dp,
                end = 16.dp,
                top = 8.dp
            ),
            verticalAlignment = Alignment.CenterVertically
        ) {
            HorizontalDivider(
                modifier = Modifier.weight(1f),
                color = Color(0xFF999999)
            )
            Text(
                "The Wedding of",
                modifier = Modifier.padding(horizontal = 8.dp),
                style = MaterialTheme.typography.titleSmall,
                color = textColor
            )
            HorizontalDivider(
                modifier = Modifier.weight(1f),
                color = Color(0xFF999999)
            )
        }
        WonderTitleText()
        Text(
            "Atas rahmat Allah SWT, kami dipertemukan dalam ikatan suci pernikahan. Dengan penuh kerendahan hati, kami mengundang Bapak/Ibu/Saudara/i untuk hadir dan memberikan doa restu.",
            style = MaterialTheme.typography.titleSmall.copy(
                fontSize = 16.sp
            ),
            textAlign = TextAlign.Center,
            color = textColor,
            modifier = Modifier.padding(16.dp)
        )
        Spacer(Modifier.height(32.dp))
        CompassDivider(
            Modifier.padding(horizontal = 16.dp, vertical = 24.dp),
            isExpanded = true
        )
    }
}